// Enumのように使いたい
class Device {
  constructor(id, name) {
    this.id = id;
  }

  static valueOf(name) {
    return this[name.toUpperCase()];
  }
}

Device.PC = new Device(1, 'PC');
// Device.FEATURE_PHONE = new Device(2, 'FEATURE_PHONE'); // 使わない
Device.SMART_PHONE = new Device(3, 'SMART_PHONE');

export default Device;
